import { FlowControlPlayoutSegmentRow } from './flow-control-playout-segment-row';
import type { FlowControlExpandSegmentMeta } from '@/helpers/flow-control-expand-segment-meta.helper';

type FlowControlOverlaySegmentHeaderProps = {
  meta: FlowControlExpandSegmentMeta;
  isActive?: boolean;
};

/** Narrow overlay: segment row chrome above the playlist panel. */
export function FlowControlOverlaySegmentHeader({ meta, isActive = false }: FlowControlOverlaySegmentHeaderProps) {
  return (
    <FlowControlPlayoutSegmentRow
      label={meta.label}
      segmentAnchor={meta.segmentAnchor}
      segmentKind={meta.segmentKind}
      segmentId={meta.segmentId}
      slotId={meta.slotId}
      isExpanded={false}
      isActive={isActive}
      disableManualStop={meta.disableManualStop}
      showMediaBelow={false}
      onToggleExpand={() => {}}
    />
  );
}
